import React, { createContext, useReducer } from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

// Check if user is already logged in from auth cookie
const getInitialAuthState = () => {
	const authStatus = Cookies.get('auth-status');
	return {
		loggedIn: authStatus === 'authenticated',
		user: null // Will be loaded asynchronously
	};
};

const initialState = getInitialAuthState();

function authReducer(state, action) {
	switch (action.type) {
	case 'log-in':
		return {
			...state,
			loggedIn: action.loggedIn,
			user: action.user || state.user
		};
	case 'log-out':
		// Remove auth status cookie on logout
		Cookies.remove('auth-status');
		return {
			...state,
			loggedIn: false,
			user: null
		};
	case 'set-user':
		return {
			...state,
			user: action.user,
			loggedIn: !!action.user
		};
	default:
		throw new Error(`Unrecognized action in AuthContext: ${action.type}`);
	}
}

export const AuthProvider = ({ children }) => {
	const [state, dispatch] = useReducer(authReducer, initialState);

	const logIn = (loggedIn, user) => {
		dispatch({
			type: 'log-in',
			loggedIn,
			user
		});
	};

	const logOut = () => {
		dispatch({
			type: 'log-out'
		});
	};

	const setUser = (user) => {
		dispatch({
			type: 'set-user',
			user
		});
	};

	return (
		<AuthContext.Provider
			value={{
				state,
				actions: {
					logIn,
					logOut,
					setUser
				}
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

AuthProvider.propTypes = {
	children: PropTypes.node.isRequired
};
